"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSeaview = function SvgSeaview(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#E6E9EE"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 16.507c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528M2 21.292c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.053 11.23a2.632 2.632 0 1 0 0-5.262 2.632 2.632 0 0 0 0 5.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 11.5 4.73-1.67M4 7l6.063.91M8 3.357l2.88 2.468M14 4.5V2m3 4 2.037-1.698M18 8.5h3m-1 4-2.686-1.791"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSeaview);
var _default = exports["default"] = Memo;